import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'
import AppProvider from './AppProvider'
import i18n from './i18n'
import { TranslationUtility } from './Utilities/translations'
import axios from 'axios'
import './analytics/posthog'
import StudioEditorV2EditorPage from './StudioEditorV2/EditorPage.jsx'
import StudioEditorV2TemplateReviewIndex from './StudioEditorV2/TemplateReviewIndex.jsx'
import StudioEditorV2TemplateReviewPage from './StudioEditorV2/TemplateReviewPage.jsx'
import StudioEditorV2McpDocsPage from './StudioEditorV2/McpDocsPage.jsx'

window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// The studio API answers 401 once the session has expired. Send the user to log in
// rather than let every save after that fail quietly -- the booking flow saves silently.
window.axios.interceptors.response.use(undefined, (error) => {
    const url = String(error?.config?.url ?? '')

    const studioApi = ['/api/v1/', '/api/adstudio/', '/api/options/', '/api/showcase/templates']

    if (error?.response?.status === 401 && studioApi.some((path) => url.includes(path))) {
        window.location.assign('/login')
    }

    return Promise.reject(error)
})

createInertiaApp({
  resolve: (name) => {
    const studioEditorV2Pages = {
      'StudioEditorV2/EditorPage': StudioEditorV2EditorPage,
      'StudioEditorV2/TemplateReviewIndex': StudioEditorV2TemplateReviewIndex,
      'StudioEditorV2/TemplateReviewPage': StudioEditorV2TemplateReviewPage,
      'StudioEditorV2/McpDocsPage': StudioEditorV2McpDocsPage,
    }
    return studioEditorV2Pages[name] || import(`../react/Pages/${name}`)
  },
  setup({ el, App, props }) {
    const translations = props?.initialPage?.props?.translations || {}
    const { __, trans } = TranslationUtility(translations)
    window.__ = __
    window.trans = trans

    // Apply the account's language before the first paint, so a user whose
    // browser last remembered a different one does not see it flash.
    const language = props?.initialPage?.props?.auth?.user?.language
    if (language) i18n.changeLanguage(language)

    const root = createRoot(el)
    root.render(
      <AppProvider>
        <App {...props} />
      </AppProvider>
    )
  },
  progress: { color: '#4B5563' },
}).then(() => document.getElementById('app')?.removeAttribute('data-page'))
